export default __webpack_public_path__ + "static/blob2-8195f693c3107892948d7a8355c38c3a.svg";